import * as React from 'react';
import Card, {
  PaddingOptions
} from '../../../sharedComponents/core/Cards/Card';
import { createUseStyles, useTheme } from 'react-jss';
import classNames from 'classnames';
import { Theme } from 'helpers/theme';
import UserUpdate from './UserUpdate';
import { createFragmentContainer, graphql } from 'react-relay';
import { ActivityCard_activity } from './__generated__/ActivityCard_activity.graphql';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    background: 'white',
    paddingTop: '14px !important'
  },
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  heading: {
    fontSize: theme.fontSizes.small,
    color: theme.colors.primaryBlack
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  graph: {
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'center',
    margin: '30px 0 45px 0'
  },
  button: {
    alignSelf: 'center',
    marginTop: '50px'
  },
  marginBottom: {
    margin: '0 0 15px 0'
  },
  divider: {
    width: 1,
    background: theme.colors.borderGrey
  },
  dividerHolder: {
    display: 'flex',
    justifyContent: 'center'
  },
  empty: {
    padding: 3,
    color: '#6a728f',
    fontSize: 14
  }
}));

export interface Statistic {
  innerRing: {
    name: string;
    value: number;
  };
  outerRing: {
    name: string;
    value: number;
  };
}

type Props = {
  leftHeading: string;
  rightHeading: string;
  options: string[];
  activity: ActivityCard_activity;
  data: Statistic;
  onClick?: Function;
  padding?: PaddingOptions;
  className?: string;
};

function ActvityCard({
  leftHeading,
  rightHeading,
  options,
  activity,
  data,
  onClick,
  padding = 'none',
  className
}: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const [currentOption, setCurrentOption] = React.useState(options[0]);
  const optionPressed = (option: string) => {
    setCurrentOption(option);
  };

  return (
    <Card
      className={classNames(classes.container, className)}
      padding={padding}
    >
      <div className={classes.root}>
        {activity &&
          (activity.edges ?? []).map(
            (act, i) => act && <UserUpdate key={i} activity={act} />
          )}
        {(activity?.edges?.length ?? 0) === 0 && (
          <div className={classes.empty}>No activity yet</div>
        )}
      </div>
    </Card>
  );
}

export default createFragmentContainer(ActvityCard, {
  activity: graphql`
    fragment ActivityCard_activity on ActivityPage {
      edges {
        ...UserUpdate_activity
      }
    }
  `
});
